import React from 'react';

import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';
import { CenteredSpinner } from '@confluence/confluence-shared-components';
import type { TemplateVariableDialogProps } from './types.ts';

export const TemplateVariableDialogLoader: LoadableType<TemplateVariableDialogProps> = LoadableLazy(
	{
		loader: async () =>
			(
				await import(
					/* webpackChunkName: "loadable-TemplateVariableDialogComponent" */ './TemplateVariableDialogComponent.tsx'
				)
			).TemplateVariableDialogComponent,
		loading: () => <CenteredSpinner size="medium" />,
	},
);
